// extracted by mini-css-extract-plugin
export default {"name":"CurrentNamePage_name__KFktt","div_svg":"CurrentNamePage_div_svg__jKV+E"};